import { useEffect, useState } from 'react';

export function useScheduledRender(active: boolean, intervalMs: number = 30000) {
  const [, setUpdate] = useState(Date.now());

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval>;

    if (active) {
      intervalId = setInterval(() => {
        setUpdate(Date.now());
      }, intervalMs);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [active, intervalMs]);
}
